<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="column">
      <woot-modal-header :header-title="pageTitle" />
      <div class="canned-preview-body">
        <div v-if="edinboxes.length" class="canned-preview-title">
          {{ $t('CANNED_MGMT.PREVIEW.CHANNELS') }}
        </div>
        <div class="canned-preview-channels">
          <div
            v-for="channel in edinboxes"
            :key="channel.id"
            class="canned-preview-channel"
          >
            {{ channel.name }}
          </div>
        </div>
        <div class="canned-preview-title">
          {{ $t('CANNED_MGMT.PREVIEW.CONTENT') }}
        </div>
        <div class="canned-preview-content">
          {{ contentMsg }}
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
/* eslint no-console: 0 */
import Modal from '../../../../components/Modal';
import { mapGetters } from 'vuex';
import { removeExtraLines } from 'dashboard/helper/commons.js';

export default {
  components: {
    Modal,
  },
  props: {
    id: { type: Number, default: null },
    edcontent: { type: String, default: '' },
    edshortCode: { type: String, default: '' },
    edinboxes: { type: Array, default: () => [] },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      content: this.edcontent,
      show: true,
      selectedChannels: [],
    };
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
    }),
    pageTitle() {
      console.log(this.edinboxes);
      return `${this.$t('CANNED_MGMT.PREVIEW.TITLE')} - ${this.edshortCode}`;
    },
    contentMsg() {
      console.log(removeExtraLines(this.content));
      return removeExtraLines(this.content);
    },
  },
};
</script>
<style scoped lang="scss">
.canned-preview-body {
  padding: 0 var(--space-medium) var(--space-medium);
  .canned-preview-title {
    font-weight: var(--font-weight-medium);
    line-height: 24px;
    color: var(--s-700);
    font-size: var(--font-size-medium);
    margin: var(--space-small) 0;
  }
  .canned-preview-channels {
    .canned-preview-channel {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 12px;
      border-radius: 16px;
      background: #f5f5f5;
      font-size: var(--font-size-normal);
      display: inline-block;
      margin: 6px;
    }
  }
  .canned-preview-content {
    font-size: var(--font-size-normal);
    background: #f7f7f7;
    padding: var(--space-normal);
    max-height: 400px;
    overflow-y: auto;
  }
}
</style>
